module.exports = __webpack_public_path__ + "static/media/2024-Retire-Ready-Box-Shareable-Social.62aee0bc.jpg";